import { render, staticRenderFns } from "./VerFeedback.vue?vue&type=template&id=07c74160&"
import script from "./VerFeedback.vue?vue&type=script&lang=js&"
export * from "./VerFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports